import { FC } from 'react';

import { Tag, Text, Tooltip, Wrap, WrapItem } from '@bonusly/design-system';

export type ValueHashtagOption = {
	value: string;
	description?: string | null;
};

type ValueHashtagPickerProps = {
	options: ValueHashtagOption[];
	value: string[];
	onChange?: (next: string[]) => void;
	isReadOnly?: boolean;
	isDisabled?: boolean;
};

export const ValueHashtagPicker: FC<ValueHashtagPickerProps> = ({ options, value, onChange, isReadOnly, isDisabled }) => {
	const toggle = (hashtag: string) => {
		if (isReadOnly || isDisabled || !onChange) {
			return;
		}

		if (value.includes(hashtag)) {
			onChange(value.filter((h) => h !== hashtag));
		} else {
			onChange([...value, hashtag]);
		}
	};

	return (
		<Wrap>
			{options.map((option) => {
				const isSelected = value.includes(option.value);

				const chip = (
					<Tag
						variant={isSelected ? 'solid' : 'subtle'}
						size="sm"
						borderRadius="full"
						fontWeight="medium"
						fontSize="sm"
						height={8}
						py={1.5}
						px={3}
						border="1px solid"
						borderColor="border.default"
						color={isSelected ? 'secondary.fgOnSurface' : 'text.default'}
						bg={isSelected ? 'secondary.bg' : 'bg.surface'}
						cursor={isReadOnly || isDisabled ? 'default' : 'pointer'}
						opacity={isDisabled ? 0.6 : 1}
						onClick={() => toggle(option.value)}
						_hover={isReadOnly || isDisabled ? undefined : { bg: isSelected ? 'secondary.bgHover' : 'secondary.bgAlpha' }}
					>
						<Text size="sm">{option.value}</Text>
					</Tag>
				);

				return (
					<WrapItem key={option.value}>
						{option.description ? (
							<Tooltip hasArrow={false} label={option.description}>
								{chip}
							</Tooltip>
						) : (
							chip
						)}
					</WrapItem>
				);
			})}
		</Wrap>
	);
};
